module.exports = "//static.hsappstatic.net/FormsUI/static-2.23336/img/types/pop_over.png"